import './VerificationStatus.css';
import { App } from '@capacitor/app';
import { useHistory } from 'react-router';
import { Button, IconButton } from '@mui/material';
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
// ICONs & SVGs
import verificationGif from '../../imgs/verification.gif'

function IdCardVerification() {
  // const history = useHistory()
  // const onBackClick = () => history.push('/home');

  const onCloseApp = async () => await App.exitApp();

  return (
    <IonicPageWrapper>
      <div id="verification_status">
        <section className="verification_status_cont">
          <img src={verificationGif} />
          <p>ID card submitted successfully !!!</p>
          <br />
          <sub>
            <b>Now, You can close app</b>
          </sub>
          <Button variant='contained' onClick={onCloseApp}
            sx={{ display: 'block', margin: '30px auto 0 auto', backgroundColor: '#F47174 !important' }}
          >
            Close App
          </Button>
        </section>
      </div>
    </IonicPageWrapper>
  );
}

export default IdCardVerification